import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import BookingCard from "../components/BookingCard";
import "../css/BookingScreen.css";
import rahul from "../assets/rahul.png";
import ram from "../assets/ram.png";
import ShopFilterComponent from "./ShopFilterComponent";
import { useNavigate } from "react-router-dom";
import PageTitle from "./PageTitleCompoent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../api"; // centralized API instance

const BookingSectionWrapper = ({ type, title, bookings }) => {
  const [showAll, setShowAll] = useState(false);
  const visibleBookings = showAll ? bookings : bookings.slice(0, 3);
  const enableScroll = bookings.length > 3;
  const navigate = useNavigate();

  const handleBookingClick = (booking) => {
    // Remove actions array (contains async functions that can't be serialized)
    const { actions, ...cleanBooking } = booking;
    navigate("/booking_detail", { state: { booking: cleanBooking, type } });
  };

  return (
    <div className={`booking-section-background-${type}`}>
      <div className={`booking-section ${enableScroll ? "scroll-enabled" : ""}`}>
        <div className="booking-section-header">
          <h3 className="booking-section-header-title">{title}</h3>
          {bookings.length > 2 && (
            <button className="view-all" onClick={() => setShowAll(!showAll)}>
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                <path
                  fill="#000"
                  d="M4 17q-.425 0-.712-.288T3 16t.288-.712T4 15h12q.425 0 .713.288T17 16t-.288.713T16 17zm2-4q-.425 0-.712-.288T5 12t.288-.712T6 11h12q.425 0 .713.288T19 12t-.288.713T18 13zm2-4q-.425 0-.712-.288T7 8t.288-.712T8 7h12q.425 0 .713.288T21 8t-.288.713T20 9z"
                />
              </svg>
              <span>{showAll ? "Show Less" : "View All"}</span>
            </button>
          )}
        </div>

        <div className={`booking-card-list ${enableScroll ? "card-scroll" : ""}`}>
          {visibleBookings.map((b, i) => (
            <div key={i} onClick={() => handleBookingClick(b)}>
              <BookingCard
                {...b}
                status={b.status}
                service_provider_name={b.service_provider_name}
                service_provider_mobile_number={b.service_provider_mobile_number}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ServiceProviderModal = ({ providers, onAssign, onClose, loading }) => {
  return (
    <div className="booking-modal-overlay" onClick={onClose}>
      <div className="booking-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="booking-modal-header">
          <h3 className="booking-model-title">Service Provider Lists</h3>
          <button className="booking-modal-close" onClick={onClose}>
            Close
          </button>
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: "1rem" }}>Loading providers...</div>
        ) : (
          <div className="booking-service-provider-list">
            {providers.length === 0 ? (
              <div style={{ textAlign: "center", padding: "1rem" }}>No providers found</div>
            ) : (
              providers.map((p, i) => (
                <div key={i} className="booking-service-provider-item">
                  <div className="booking-provider-info">
                    <img
                      src={p.avatar || rahul}
                      alt={p.name}
                      className="booking-provider-avatar"
                    />
                    <div className="booking-provider-details">
                      <span className="booking-provider-name">{p.name}</span>
                      <span className="booking-provider-type">{p.email}</span>
                      <span
                        className={`booking-provider-status ${
                          p.available ? "booking-available" : "booking-not-available"
                        }`}
                      >
                        {p.available ? "Available" : "Not Available"}
                      </span>
                    </div>
                  </div>
                  <button
                    disabled={!p.available}
                    className="booking-assign-button"
                    onClick={() => onAssign(p.name, p.id)}
                  >
                    Assign
                  </button>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default function BookingsScreen() {
  const [modalOpen, setModalOpen] = useState(false);
  const [providers, setProviders] = useState([]);
  const [loadingProviders, setLoadingProviders] = useState(false);
  const [filters, setFilters] = useState({ name: false, type: false });
  const [inputValues, setInputValues] = useState({ name: "", type: "" });
  const [showFilters, setShowFilters] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState(null);

  // API states
  const [newBookings, setNewBookings] = useState([]);
  const [assignedBookings, setAssignedBookings] = useState([]);
  const [ongoingBookings, setOngoingBookings] = useState([]);
  const [completedBookings, setCompletedBookings] = useState([]);

  // ✅ Prevent toast error (safe unmount)
  useEffect(() => {
    let isMounted = true;
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const fetchBookings = async () => {
      try { 
        const response = await api.get("admin/bookings/");
        console.log("✅ Bookings API response:", response.data);
        const data = response.data;

        const formatBooking = (item, statusType) => ({
          bookingId: item.id,
          name: item.customer_name,
          avatar: item.customer_image
            ? `${api.defaults.baseURL.split("/api")[0]}${item.customer_image}`
            : rahul,
          type: item.service_type_display,
          datetime: `${item.preferred_date} - ${item.preferred_time}`,
          amount: item.final_cost,
          phone: item.customer_phone,
          email: item.customer_email,
          petName: item.pet_name,
          petType: item.pet_category,
          petBreed: item.pet_breed,
          petGender: item.pet_gender,
          petDob: item.pet_dob,
          petAge: item.pet_age,
          address: item.customer_address,
          status: statusType,

          service_provider_name:
            ["assigned", "ongoing", "completed"].includes(statusType)
              ? item.service_provider_name
              : null,
          service_provider_mobile_number:
            ["assigned", "ongoing", "completed"].includes(statusType)
              ? item.service_provider_mobile_number
              : null,

          actions: [
            ...(statusType === "new"
              ? [
                  {
                    label: "Reject",
                    type: "reject",
                    onClick: async (e) => {
                      if (e && e.stopPropagation) e.stopPropagation();

                      try {
                        const payload = { id: item.id };
                        console.log("🗑️ Rejecting booking:", payload);

                        await api.delete("admin/booking-assignment/", { data: payload });

                        toast.success("Booking rejected successfully!");

                        setNewBookings((prev) =>
                          prev.filter((b) => b.bookingId !== item.id)
                        );
                      } catch (error) {
                        console.error("❌ Error rejecting booking:", error);
                        toast.error("Failed to reject booking. Please try again.");
                      }
                    },
                  },
                  {
                    label: "Assign",
                    type: "assign",
                    onClick: async (e) => {
                      if (e && e.stopPropagation) e.stopPropagation();
                      setSelectedBookingId(item.id);
                      await fetchProviders(item.id);
                    },
                  },
                ]
              : []),
          ],
        });

        setNewBookings(data.new_booking.map((b) => formatBooking(b, "new")));
        setAssignedBookings(data.assigned_booking.map((b) => formatBooking(b, "assigned")));
        setOngoingBookings(data.ongoing_booking.map((b) => formatBooking(b, "ongoing")));
        setCompletedBookings(data.completed_booking.map((b) => formatBooking(b, "completed")));
      } catch (error) {
        console.error("Error fetching bookings:", error);
      }
    };

    fetchBookings();
  }, []);

  const fetchProviders = async (bookingId) => {
    try {
      setLoadingProviders(true);
      setModalOpen(true);
      setProviders([]);

      console.log("📦 Fetching providers for booking:", bookingId);

      const response = await api.get(
        `admin/booking-assignment/?booking_id=${bookingId}`
      );

      console.log("✅ Provider API response:", response.data);

      const data = response.data;

      const allProviders = [
        ...(data.available_providers || []).map((p) => ({
          id: p.id,
          name: p.name,
          email: p.email,
          available: true,
          avatar: rahul,
        })),
        ...(data.unavailable_providers || []).map((p) => ({
          id: p.id,
          name: p.name,
          email: p.email,
          available: false,
          avatar: ram,
        })),
      ];

      setProviders(allProviders);
    } catch (error) {
      console.error("Error fetching providers:", error);
    } finally {
      setLoadingProviders(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleInputChange = (key, value) => {
    setInputValues((prev) => ({ ...prev, [key]: value.trim().toLowerCase() }));
  };

  const getFilteredBookings = (bookings) =>
    bookings.filter((b) => {
      const name = b.name?.toLowerCase() || "";
      const type = b.type?.toLowerCase() || "";
      return (
        (!inputValues.name || name.includes(inputValues.name)) &&
        (!inputValues.type || type.includes(inputValues.type))
      );
    });

  const onAssign = async (providerName, providerId) => {
    if (!selectedBookingId) {
      toast.error("No booking selected!");
      return;
    }

    try {
      const payload = {
        booking_id: selectedBookingId,
        service_provider_id: providerId,
      };

      console.log("📦 Assigning provider:", payload);

      const response = await api.post("admin/booking-assignment/", payload);

      console.log("✅ Assignment response:", response.data);
      toast.success(`Successfully assigned ${providerName}`);

      setModalOpen(false);
    } catch (error) {
      console.error("❌ Error assigning provider:", error);
      toast.error("Failed to assign provider. Please try again.");
    }
  };

  return (
    <div className="booking-container">
      <Sidebar />
      <div className="booking-main">
        <Header />
        <div className="booking-content">
          <div className="booking-heading-row">
            <PageTitle title="Bookings" />
            <div className="booking-and-shop-filter">
              <ShopFilterComponent
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                filters={filters}
                inputValues={inputValues}
                onFilterChange={handleFilterChange}
                onInputChange={handleInputChange}
                filterKeys={["name", "type"]}
              />
            </div>
          </div>

          {modalOpen && (
            <ServiceProviderModal
              providers={providers}
              onAssign={onAssign}
              onClose={() => setModalOpen(false)}
              loading={loadingProviders}
            />
          )}

          <div className="booking-grid">
            <BookingSectionWrapper
              title="New Bookings"
              type="new"
              bookings={getFilteredBookings(newBookings)}
            />
            <BookingSectionWrapper
              title="Assigned Bookings"
              type="assigned"
              bookings={getFilteredBookings(assignedBookings)}
            />
            <BookingSectionWrapper
              title="Ongoing Bookings"
              type="ongoing"
              bookings={getFilteredBookings(ongoingBookings)}
            />
            <BookingSectionWrapper
              title="Completed Bookings"
              type="completed"
              bookings={getFilteredBookings(completedBookings)}
            />
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
